import React from 'react'
import {
  Divider,
  Grid,
  Stack,
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import Logo from '../logo.js'

const InvoicePages = ({
  classes,
  groupDetails,
  patient,
  dateString,
  prodList,
  prodListColumnsInv,
  totals,
}) => {
  const rowBase = prodList.length > 0 ? Math.trunc(800 / prodList.length) : 46
  const rowHeight = rowBase > 46 ? 46 : Math.max(rowBase - 1, 24)
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'ZAR',
  })

  return (
    <>
      <div contentEditable={true} suppressContentEditableWarning={true}>
        <article className={classes.article0}>
          <Grid container item xs={12} spacing={0}>
            <Grid className={classes.upAndLeft} item xs={10}>
              <Stack spacing={1}>
                <h3>{groupDetails.hdetail1}</h3>
                <h3>{groupDetails.hdetail2}</h3>
                <b>{groupDetails.hdetail3}</b>
              </Stack>
            </Grid>
            <Grid className={classes.upAndRight} item xs={2}>
              <Logo />
            </Grid>
          </Grid>
        </article>
        <article className={classes.article0}>
          <Grid container item xs={12} spacing={0}>
            <Grid className={classes.upAndRight} item xs={12}>
              {groupDetails.hdetail4}
            </Grid>
            <Grid className={classes.upAndLeft} item xs={8}>
              <b>{groupDetails.hdetail5}</b>
            </Grid>
            <Grid className={classes.upAndRight} item xs={4}>
              {groupDetails.hdetail6}
            </Grid>
            <Grid className={classes.upAndLeft} item xs={8}>
              <b>{groupDetails.hdetail7}</b>
            </Grid>
            <Grid className={classes.upAndRight} item xs={4}>
              {groupDetails.hdetail8}
            </Grid>
            <Grid className={classes.upAndLeft} item xs={8}>
              <b>{groupDetails.hdetail9}</b>
            </Grid>
            <Grid className={classes.upAndRight} item xs={4}>
              {groupDetails.hdetail10}
            </Grid>
          </Grid>
        </article>
        <article className={classes.article2}>
          <Grid container item xs={12} spacing={0}>
            <Grid className={classes.upAndBold} item xs={4}>
              Tax Invoice
            </Grid>
            <Grid className={classes.upAndRight} item xs={8}>
              Invoice Date: {dateString}
            </Grid>
            <Grid className={classes.upAndBold} item xs={9}>
              {patient.firstName} {patient.patientName}
            </Grid>
            <Grid className={classes.upAndRight} item xs={3}>
              Medical Aid: {patient.medicalAid}
            </Grid>
            <Grid className={classes.upAndRight} item xs={12} editable>
              Member No: {patient.memberNo}
            </Grid>
            <Grid className={classes.upAndRight} item xs={12} editable>
              Authorization No: {patient.authNo}
            </Grid>
          </Grid>
        </article>
        <article className={classes.article1}>
          <br />
          <br />
          <span>
            Patient: {patient.firstName} {patient.patientName},
            d.o.b: {patient.dateOfBirth}, Dep Code: {patient.dependentCode}
          </span>
          <Divider style={{ background: 'black' }} variant="left" />
          <span className={classes.finePrint}>
            Treating Provider: <b>{groupDetails.hdetail1}</b>, {groupDetails.hdetail11}, Date of Service: {dateString}<br />
          </span>
          <span className={classes.finePrint}>
            ICD10 Codes: {patient.ICD10Codes}
          </span>
          <br />
          <br />
        </article>
      </div>

      <div style={{ marginLeft: '80px' }}>
        <div style={{ height: 790 }}>
          <DataGrid
            className={classes.prodGridInv}
            rows={prodList}
            columns={prodListColumnsInv}
            rowHeight={rowHeight}
            autoHeight='true'
            hideFooter='true'
            showCellRightBorder='true'
            showColumnRightBorder='true'
          />
        </div>
      </div>

      {totals > 0 ? (
        <article className={classes.article4}>
          <Grid container item xs={12} spacing={0} contentEditable={true} suppressContentEditableWarning={true}>
            <Grid className={classes.upAndBold} item xs={9}>
              Totals
            </Grid>
            <Grid className={classes.upAndUnderline} item xs={3}>
              {formatter.format(totals)}
            </Grid>
          </Grid>
        </article>
      ) : ''}

      <article className={classes.article3}>
        <Grid className={classes.finePrint2} container item xs={12} spacing={0}>
          <Grid item xs={2}>
            Bank Details
          </Grid>
          <Grid item xs={10}>
            <span>
              <b>{groupDetails.bdetail1}, {groupDetails.bdetail2},</b> Branch <b>{groupDetails.bdetail5}, </b>
              Account no: <b>{groupDetails.bdetail3},</b> Account Type: <b>{groupDetails.bdetail4}</b>
            </span>
          </Grid>
          <Divider />
          <Grid item xs={2}>
            Company Info
          </Grid>
          <Grid item xs={10}>
            <b>{groupDetails.cdetail1}</b>
          </Grid>
          <Divider />
          <Grid item xs={2}>
            EFT Info
          </Grid>
          <Grid item xs={10}>
            {groupDetails.edetail1} <b>{patient.firstName} {patient.patientName}</b>{groupDetails.edetail2} {groupDetails.edetail3}
          </Grid>
        </Grid>
      </article>
    </>
  )
}

export default InvoicePages
